import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function About() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 bg-white">
        <div className="w-full px-6 md:px-10 lg:px-14 pt-28 md:pt-36 pb-20 md:pb-28">
          <div className="max-w-3xl mx-auto">
            <span className="inline-block text-sm font-medium text-[#4CAF50] border border-[#4CAF50]/30 rounded-full px-4 py-1.5 mb-5">
              About Us
            </span>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight mb-8">
              About ScanDoc
            </h1>

            <div className="space-y-10 text-gray-700 text-sm md:text-base leading-relaxed">
              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  Our Mission
                </h2>
                <p>
                  At ForceKeys, we believe that document management should be
                  effortless, fast, and accessible to everyone. ScanDoc was
                  born from a simple idea: turn any smartphone into a powerful
                  portable scanner and PDF workstation — no extra hardware
                  needed.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  Who We Are
                </h2>
                <p>
                  ForceKeys is a mobile-first software company dedicated to
                  building productivity tools that fit in your pocket. Our team
                  of engineers and designers work every day to refine ScanDoc,
                  adding new features, improving accuracy, and making the user
                  experience as smooth as possible.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  What We Believe
                </h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <strong>Privacy first:</strong> Your documents belong to
                    you. We store data locally by default and never access your
                    files without permission.
                  </li>
                  <li>
                    <strong>Quality without compromise:</strong> Every scan,
                    every filter, and every OCR result should meet professional
                    standards.
                  </li>
                  <li>
                    <strong>Simplicity wins:</strong> Powerful tools do not
                    need complicated interfaces. If it takes more than two
                    taps, we rethink it.
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  Get in Touch
                </h2>
                <p className="mb-4">
                  We love hearing from our users. Whether you have feedback,
                  feature requests, or just want to say hello, reach out to us.
                </p>
                <div className="flex flex-col sm:flex-row flex-wrap gap-4">
                  <a
                    href="mailto:scandoc@forcekeys.com"
                    className="inline-flex items-center gap-2 bg-[#4A90D9] hover:bg-[#3A7BC8] text-white text-sm font-semibold px-6 py-3 rounded-full transition-colors whitespace-nowrap"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-mail-line text-base"></i>
                    </span>
                    scandoc@forcekeys.com
                  </a>
                  <a
                    href="https://wa.me/2130777720574"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white text-sm font-semibold px-6 py-3 rounded-full transition-colors whitespace-nowrap"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-whatsapp-line text-base"></i>
                    </span>
                    +213 (0) 7 77 72 05 74
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.forcekeys.scandoc.app"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 border-2 border-[#4A90D9] text-[#4A90D9] hover:bg-[#4A90D9]/5 text-sm font-semibold px-6 py-3 rounded-full transition-colors whitespace-nowrap"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-google-play-fill text-base"></i>
                    </span>
                    Get ScanDoc
                  </a>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}